import 'core-js';

import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { loadingBarMiddleware } from 'react-redux-loading-bar'

import rootReducer from './store/reducers';
import 'bootstrap/dist/css/bootstrap.css'


import {
    BrowserRouter as Router,
    Route,
    Switch
} from 'react-router-dom'

import Dashboard from './containers/DashboardContainer';
import BuyTickets from './containers/BuyTicketsContainer';
import PastEvents from './containers/PastEventsContainer';
import Promo from './containers/PromoContainer';
import V2Promo from './containers/V2PromoContainer';
import V2ClaimPage from './components/v2/V2ClaimPage';

function RootRedirect() {
    window.location.replace('https://split50-50.com.au/')
    return null
}

const loggerMiddleware = createLogger()

const store = createStore(
    rootReducer,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware,
        loadingBarMiddleware())
)


ReactDOM.render(

    <Provider store={store}>

        <Router>
            <Switch>
                <Route exact path="/" component={RootRedirect} />
                <Route exact path="/claim/:claimId" component={V2ClaimPage} />
                <Route exact path="/*/buy" component={BuyTickets} />
                <Route exact path="/*/events" component={PastEvents} />
                <Route exact path="/*/promo" component={V2Promo} />
                <Route exact path="/*/promos/*" component={Promo} />
                <Route exact path="/*" component={Dashboard} />
            </Switch>
        </Router>
    </Provider>
    ,

    document.getElementById('root')
);
